import { StaticBaseDao } from '@/dao';
import { ManagerUser, JsonWebToken, LoginRequest, ResetPasswordRequest } from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';
import { useUserStore } from '@/stores';

export class UserDao extends StaticBaseDao {
    public static async User(): Promise<ManagerUser | null> {
        return this.BaseFetch(ManagerUser, `User/User`, 'GET');
    }
    public static async Logout(): Promise<boolean | null> {
        return this.Delete(`User/Login`);
    }
    public static async LoginOauth2(token: JsonWebToken): Promise<ManagerUser | null> {
        return this.BaseFetch(ManagerUser, `User/LoginOauth2`, 'POST', token);
    }
    public static async Login(userLogin: LoginRequest): Promise<ManagerUser | null> {
        return this.BaseFetch(ManagerUser, `User/Login`, 'POST', userLogin);
    }
    public static async RequestPasswordReset(request: ResetPasswordRequest): Promise<boolean | null> {
        return this.Post(`User/RequestPasswordReset`, request);
    }
    public static async ResetPassword(request: ResetPasswordRequest): Promise<boolean | null> {
        return this.Post(`User/ResetPassword`, request);
    }
    public static async DisableUser2FA(userId: number, until: Date): Promise<boolean | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Get(
            `User/DisableUser2FA` +
                '?' +
                (userId == undefined ? '' : `userId=${userId}`) +
                '&' +
                (until == undefined ? '' : `until=${formatDateIso(until)}`),
        );
    }
}
